import { useTranslation as libUseTranslations } from 'react-i18next';

import * as i18n from './i18n';

// hack to enable auto import
export const useTranslation = libUseTranslations;
export type { TFunction } from './i18n';
export default i18n;
